import styled from 'styled-components';
import ExternalLink from 'app/components/ExternalLink/ExternalLink';
import { playGrey5 } from '../../../ui-components/design-tokens';
import { device } from '../../../ui-components/breakpoints';
import { PlayTextStyles } from '../../../ui-components/typography/PlayText/PlayText.styles';
import PlayText from '../../../ui-components/typography/PlayText/PlayText';

export const StyledNoJavascriptMessage = styled.div`
    background-color: ${playGrey5};
    text-align: center;
    height: 100%;
    position: absolute;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Wrapper = styled.div`
    padding: 0 10px 0 10px;
`;

export const RightsLink = styled(ExternalLink)`
    ${PlayTextStyles};

    display: block;
    margin-top: 10px;

    @media ${device.GteMedium} {
        margin-top: 15px;
    }
`;

export const Description = styled(PlayText)`
    display: block;
    margin-top: 10px;
`;
